import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import PlayerLoop from './PlayerLoop'
import PlantelHeader from './PlantelHeader'
import {
  Wrap,
  ColLeft,
  ColRight,
  LargeColLeft,
  LargeColRight,
  FullCentered,
  spacedVertical,
} from '@/styles/Layout'

const PlantelWrap = styled(FullCentered)`
  display: grid;
  padding: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
`

const PlantelHeaderWrap = styled(PlantelHeader)`
  grid-column: span 3;
  @media (max-width: 1200px) {
    grid-column: span 1;
  }
`

const Plantel = ({ mode = 'single' }) => {
  const { players } = useStaticQuery(graphql`
    query players {
      players: allWpPlayer(sort: { fields: playerFields___number }) {
        edges {
          node {
            title
            playerFields {
              number
              born
              died

              clubs {
                periodo
                club {
                  name
                }
              }
              position {
                name
              }
            }
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 600, formats: [WEBP, AVIF])
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  return (
    <PlantelWrap>
      <PlantelHeaderWrap></PlantelHeaderWrap>

      {players.edges.map(({ node }) => (
        <PlayerLoop key={node.title} player={node} />
      ))}
    </PlantelWrap>
  )
}

export default Plantel
